/* placeAutocompleteShadowPatch.js — executes once when imported */
let prototypePatched = false;

export function AddressAutoCompleteStylePatch() {
  if (prototypePatched) return;               // ✅ already done

  prototypePatched = true;
  // Currently Google PlaceAutocompleteElement element has a closed Shadow Root, so by design the component
  // has been created with the intention of its internals and styles not being changeable.
  // Once the closed shadow root is created then the element inside can not be modified, so to override the
  // style one can append style at the time of shadow being attached to an element
  const attachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    // Check if we are the new Google places autocomplete element...
    if (this.localName === "gmp-place-autocomplete") {
      // If we are, we need to override the default behaviour of attachShadow() to
      // set the mode to open to allow us to crowbar a style element into the shadow DOM.
      const shadow = attachShadow.call(this, {
        ...init,
        mode: "open"
      });

      if (!shadow.getElementById('gmpx-custom-style')) {
        const style = document.createElement("style");
        style.id = 'gmpx-custom-style';
        // Apply our own styles to the shadow DOM.
        style.textContent = `
          .widget-container {
            border: none !important;
            border-bottom: 1px solid !important;
          }
          // .input-container {
          //   // padding: 0px !important;
          // }
          // .focus-ring {
          //   display: none !important;
          // }
          // .dropdown {
          // }
          // .place-autocomplete-element-place-icon {
          //   display: none !important;
          // }
          // .place-autocomplete-element-text-div {
          // }
          // .place-autocomplete-element-place-name {
          // }
          // .place-autocomplete-element-place-details {
          // }
          // .place-autocomplete-element-place-result--matched {
          // }
          // ul {
          // }
          // li {
          // }
          // li:hover {
          // }
          // input {
          // }
        `;

        shadow.appendChild(style);
      }

      if (!shadow.getElementById('gmpx-custom-script')) {
        const script = document.createElement('script');
        script.id = 'gmpx-custom-script';
        script.textContent = `
        /* this runs inside the shadow root’s execution context */
        function updateTextValue(el, value) {
          el.value = value;
        }
      `;
        shadow.appendChild(script);
      }

      // Set the shadowRoot property to the new shadow root that has our styles in it.
      return shadow;
    }
    // ...for other elements, proceed with the original behaviour of attachShadow().
    return attachShadow.call(this, init);
  };

  // const original = Element.prototype.attachShadow;

  // Element.prototype.attachShadow = function (init) {
  //   const shadow = original.call(this, init);

  //   if (this.localName === 'gmp-place-autocomplete') {
  //     // Don’t add the style twice to the *same* widget
  //     if (!shadow.getElementById('gmpx-custom-style')) {
  //       const style = document.createElement('style');
  //       style.id = 'gmpx-custom-style';
  //       style.textContent = /* css */`
  //         .widget-container { border: none !important; }
  //         .input-container { padding: 0 !important; }
  //         .focus-ring      { display: none !important; }
  //         /* …rest of your rules… */
  //       `;
  //       shadow.appendChild(style);
  //     }
  //   }
  //   return shadow;
  // };
}
